module.exports = __webpack_public_path__ + "static/agro_baggio_john_deere_logo-e169925d811804c6186a62250e3aa75e.png";